import { render, staticRenderFns } from "./DepartureTabsTicket.vue?vue&type=template&id=20c7d6c0&scoped=true&"
import script from "./DepartureTabsTicket.vue?vue&type=script&lang=js&"
export * from "./DepartureTabsTicket.vue?vue&type=script&lang=js&"
import style0 from "./DepartureTabsTicket.vue?vue&type=style&index=0&id=20c7d6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c7d6c0",
  null
  
)

export default component.exports